exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica,\n    Arial, sans-serif;\n  background: #fafafa;\n}\n#stories {\n  transition: margin 0.3s ease-out;\n}\n@media (max-width: 768px) {\nhtml,\n  body {\n    height: 100vh;\n}\n#stories {\n    width: 9999vw;\n    position: relative;\n}\n}\n", ""]);

